import { render, staticRenderFns } from "./index.vue?vue&type=template&id=982e2f38&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=982e2f38&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=982e2f38&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982e2f38",
  null
  
)

export default component.exports